export default __webpack_public_path__ + "static/media/Imageexpertsection.b5e356a8.svg";